import { useMemo } from 'react';
import { IExpression } from '../../IExpression';
import { getMaterializedExpressionReferences } from '../../evaluate/getMaterializedExpressionReferences';

/**
 * A partire da un'espressione, ottiene la lista di tutti i riferimenti
 * e per ognuno il path completo relativo al form.
 */
export function useMaterializedExpressionReferences(
  name: string,
  expression:
    | Array<IExpression | null | undefined>
    | IExpression
    | null
    | undefined,
) {
  return useMemo(() => {
    return getMaterializedExpressionReferences({ name, expression });
  }, [name, expression]);
}
